import defaultConfig from './config.production';

export const port = process.env.PORT || 3000;

export default {
  ...defaultConfig,
  api: {
    ...defaultConfig.api,
  },
};



// WEBPACK FOOTER //
// /opt/build/repo/src/app/config/config.staging.js